/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  TRANSACTION_RENTAL,
  TRANSACTION_SALE,
  TRANSACTION_SEASONAL_RENTAL
} from '../../enums/TransactionCodes.mjs'

export type PriceLabelProps = {
  value: TransactionType
}

function PriceLabel (props: PriceLabelProps) {
  const { value } = props
  const intl = useIntl()

  if (value === TRANSACTION_RENTAL) {
    return intl.formatMessage({
      id: 'rent',
      defaultMessage: 'Loyer'
    })
  }
  if (value === TRANSACTION_SEASONAL_RENTAL) {
    return intl.formatMessage({
      id: 'bed_night',
      defaultMessage: 'Nuitée'
    })
  }
  if (value === TRANSACTION_SALE) {
    return intl.formatMessage({
      id: 'sale_price',
      defaultMessage: 'Prix de vente'
    })
  }
  return intl.formatMessage({
    id: 'price',
    defaultMessage: 'Prix'
  })
}

export default PriceLabel
